import { isEmpty } from "../src/components/lib/isEmpty";
import { useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getUserData } from "../src/components/actions/userlogin";
import { getGamedatas } from "../src/components/actions/gameSettings";
import { getCmsList } from "../src/components/actions/cms";
import { getsiteSettings } from "../src/components/actions/siteSettings";
import SocketContext from "../src/components/context/SocketContext";
import { useHistory } from "react-router-dom";
import { logout } from "./components/actions/logout";
import isLogin from "./components/lib/isLogin";
import { removeAuthToken } from "./components/lib/localStorage";
import { removeAuthorization } from "./components/config/axios";
const HelperRoute = () => {
  const history = useHistory();
  let dispatch = useDispatch();
  const socketContext = useContext(SocketContext);
  const { isAuth, userId } = useSelector((state) => state.auth);
  // console.log('HelperRoute', isAuth, userId)

  useEffect(() => {
    getGamedatas(dispatch);
    getCmsList(dispatch);
    getsiteSettings(dispatch);
    // console.log('HelperRoute', isAuth, userId)
    if (!isEmpty(localStorage.getItem("user_token")) && isLogin()) {
      getUserData(dispatch);
    } else if (!isEmpty(localStorage.getItem("user_token"))) {
      removeAuthToken();
      removeAuthorization();
    }
  }, [isAuth]);

  useEffect(() => {
    socketContext.socket.on("FORCE_LOGOUT", (result) => {
      // Backend emits FORCE_LOGOUT with userId - log out this session
      logout(history, dispatch);
    });
    return () => {
      socketContext.socket.off("FORCE_LOGOUT");
    };
  }, [socketContext]);
};

export default HelperRoute;
